"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CheckCircle } from "lucide-react";
export default function BuyerPortal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const features = ["Access real-time inventory and pricing", "Streamlined procurement workflows", "Global shipping coordination", "Dedicated buyer support team"];
  return <section id="buyer-portal" ref={ref} className="relative w-full bg-primary overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        {}
        <div className={`relative z-10 flex flex-col justify-center px-6 sm:px-12 lg:px-16 py-16 lg:py-24 transition-all duration-700 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <div className="max-w-xl">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-white/90 mb-6 tracking-tight">
              Buyer Portal
            </h2>
            
            <p className="text-lg sm:text-xl text-white/90 mb-8 leading-relaxed">
              Experience seamless procurement with our comprehensive buyer platform. 
              Connect directly with global suppliers and manage your supply chain with confidence.
            </p>

            <ul className="space-y-4 mb-10">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3 group transition-transform duration-200 hover:scale-105">
                  <CheckCircle className="w-6 h-6 text-accent-dark flex-shrink-0 mt-0.5" />
                  <span className="text-white/90 text-base sm:text-lg">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <div className="flex flex-wrap gap-4">
              <button className="btn-primary">
                Access Portal
              </button>
              <button className="inline-flex items-center justify-center rounded-sm bg-transparent border-2 border-white/30 text-white/90 px-8 py-3 font-display font-semibold text-base hover:bg-white/10 hover:border-white/50 transition-all duration-150">
                Learn More
              </button>
            </div>
          </div>
        </div>

        {}
        <div className={`relative h-[400px] lg:h-auto transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/global_port_dusk_aerial.png)] bg-cover bg-center" />
          <div className="absolute inset-0 bg-primary/30" />
        </div>
      </div>
    </section>;
}